<h2 mat-dialog-title>Service Planner</h2>

<mat-dialog-content>
  <!-- <mat-card>
    <mat-card-content>
      <h3>Service Details</h3>
      <section></section>
    </mat-card-content>
  </mat-card> -->

  <div class="row">
    <div class="col-sm-4">
      <table>
        <tr>
          <td><strong>Date:</strong></td>
          <td></td>
          <td>{{ data.serviceInformation.date | date:'dd MMM yyyy hh:mm a' }}</td>
        </tr>
        <tr>
          <td><strong>Details:</strong></td>
          <td></td>
          <td>{{ data.serviceInformation.detailsOfService }}</td>
        </tr>
        <tr>
          <td><strong>Aiport Protocol:</strong></td>
          <td></td>
          <td>{{ data.serviceInformation.isProtocolRequired == true ? "Yes" : "No" }}</td>
        </tr>
        <tr *ngIf="data.serviceInformation.requiredResourceCount && data.serviceInformation.requiredResourceCount > 0">
          <td><strong>Resources Required:</strong></td>
          <td></td>
          <td>{{ data.serviceInformation.requiredResourceCount }} Resource{{ data.serviceInformation.requiredResourceCount > 1 ? 's' : '' }} required</td>
        </tr>
        <tr *ngIf="data.serviceInformation.requiredAssetCount && data.serviceInformation.requiredAssetCount > 0">
          <td><strong>Assets Required:</strong></td>
          <td></td>
          <td>{{ data.serviceInformation.requiredAssetCount }} Asset{{ data.serviceInformation.requiredAssetCount > 1 ? 's' : '' }} required</td>
        </tr>
      </table>
    </div>
    <div class="col-sm-8">
      <table>
        <tr>
          <td><strong>Pick Up Address:</strong></td>
          <td></td>
          <td>{{ data.serviceInformation.startAddress.formattedAddress }}</td>
        </tr>
        <tr>
          <td><strong>Drop Off Address:</strong></td>
          <td></td>
          <td>{{ data.serviceInformation.endAddress.formattedAddress }}</td>
        </tr>
        <tr>
          <td><strong>Special Requests:</strong></td>
          <td></td>
          <td>{{ data.serviceInformation.specialRequests }}</td>
        </tr>
      </table>
    </div>
  </div>
  <!-- <mat-divider></mat-divider> -->
  <mat-horizontal-stepper [linear]="isLinear" #stepper (selectionChange)="onStepChange($event)">
    <mat-step>
      <ng-template matStepLabel>Resources</ng-template>
      <div class="row">
        <div class="col-sm-4">
          <mat-form-field>
            <input #filterServicesInput matInput (keyup)="applyServiceInformationObjectFilter($event.target.value)" placeholder="Search for Resource" autocomplete="on">
          </mat-form-field>
        </div>
      </div>
      <div class="col-sm-12">
      <mat-table *ngIf="resourceObjects.filteredData.length > 0" [dataSource]="resourceObjects">
        <ng-container matColumnDef="selected">
          <mat-header-cell *matHeaderCellDef> Selected </mat-header-cell>
          <mat-cell *matCellDef="let resource"><mat-checkbox [checked]="isResourceSelected(resource)" (change)="toggleResourceSelection(resource)"></mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
          <mat-cell *matCellDef="let resource"><b>{{ resource.firstName }} {{ resource.lastName }}</b></mat-cell>
        </ng-container>
        <ng-container matColumnDef="msisdn">
          <mat-header-cell *matHeaderCellDef> Mobile Number </mat-header-cell>
          <mat-cell *matCellDef="let resource"> {{ resource.msisdn || 'unknown' }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="state">
          <mat-header-cell *matHeaderCellDef> Current State </mat-header-cell>
          <mat-cell *matCellDef="let resource">
            <mat-chip-list>
              <mat-chip style="background-color: green; color: white;" *ngIf="resource.responseServiceActionActiveAndListening === true">
                Available
              </mat-chip>
              <mat-chip style="background-color: grey; color: white;" *ngIf="resource.responseServiceActionActiveAndListening === false">
                Unavailable</mat-chip>
            </mat-chip-list>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="appVersion">
          <mat-header-cell *matHeaderCellDef> App Version </mat-header-cell>
          <mat-cell *matCellDef="let resource"> {{ resource.packageInfo?.version }} {{resource.packageInfo?.buildNumber}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="role">
          <mat-header-cell *matHeaderCellDef> Assigned Role </mat-header-cell>
          <mat-cell *matCellDef="let resource">
            <mat-form-field appearance="fill">
              <mat-label *ngIf=(isResourceSelected(resource))>Select Resource Role</mat-label>
              <mat-select [(ngModel)]="resourceRoleSelections[resource.key]" [disabled]=(!isResourceSelected(resource)) (selectionChange)="assignResourceRole(resource, $event.value)">
                <mat-option *ngFor="let role of resourceRoles" [value]="role">
                  {{role}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="info">
          <mat-header-cell *matHeaderCellDef> Info </mat-header-cell>
          <mat-cell *matCellDef="let resource"> <strong>{{ getResourceSchedule(resource.key) }}</strong> </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="resourceColumns"></mat-header-row>
        <mat-row  *matRowDef="let resource; columns: resourceColumns;"></mat-row>
      </mat-table>
      <mat-paginator #paginator [hidden]="resourceObjects.filteredData.length == 0" [length]="totalLength" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions">
      </mat-paginator>
      <div *ngIf="resourceObjects.filteredData.length == 0" class="row">
        <div class="card card-pricing" style="box-shadow: 0 1px 4px 0 rgba(255, 255, 255, 0.14);">
          <div class="card-body">
            <div class="card-icon icon-primary">
              <i class="material-icons">search</i>
            </div>
            <h3 class="card-title">No Resources Found</h3>
            <p class="card-descriptiona">
              Try adjusting the search criteria for more results.
            </p>
          </div>
        </div>
      </div>
    </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Assets</ng-template>
      <div class="row">
        <div class="col-sm-4">
          <mat-form-field>
            <input #filterServicesInput matInput (keyup)="applyAssetInformationObjectFilter($event.target.value)" placeholder="Search for Asset" autocomplete="on">
          </mat-form-field> 
        </div>
        <div class="col-sm-4">
            <button mat-button (click)="addRentalAsset()" class="btn btn-primary" *ngIf="(this.data.rental)">Add Temporary Vehicle (Rental)</button>
        </div>
        
      </div>
      <div class="col-sm-12">
      <mat-table *ngIf="assetObjects.filteredData.length > 0" [dataSource]="assetObjects">
        <ng-container matColumnDef="selected">
          <mat-header-cell *matHeaderCellDef> Selected </mat-header-cell>
          <mat-cell *matCellDef="let asset"><mat-checkbox [checked]="isAssetSelected(asset)" (change)="toggleAssetSelection(asset)"></mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="vehicleType">
          <mat-header-cell *matHeaderCellDef> Vehicle </mat-header-cell>
          <mat-cell *matCellDef="let asset"><b>{{ asset.make }} {{ asset.model}}</b></mat-cell>
        </ng-container>
        <ng-container matColumnDef="registrationNumber">
          <mat-header-cell *matHeaderCellDef> Registration Number</mat-header-cell>
          <mat-cell *matCellDef="let asset"> {{asset.registrationNumber}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="state">
          <mat-header-cell *matHeaderCellDef> Current State </mat-header-cell>
          <mat-cell *matCellDef="let asset">
            <mat-chip-list>
              <mat-chip style="background-color: green; color: white;" *ngIf="asset.state === 'Available'">
                Available
              </mat-chip>
              <mat-chip style="background-color: #478cd6; color: white;" *ngIf="asset.state === 'In Use'">
                In Use
              </mat-chip>
              <mat-chip style="background-color: #ffe348; color: white;" *ngIf="asset.state === 'Maintenance'">
                Maintenence
              </mat-chip>
              <mat-chip style="background-color: #fd6149; color: white;" *ngIf="asset.state === 'Retired'">
                Retired
              </mat-chip>
            </mat-chip-list>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="resources">
          <mat-header-cell *matHeaderCellDef> Resources </mat-header-cell>

          <mat-cell *matCellDef="let asset">
            <mat-form-field appearance="fill">
              <mat-label *ngIf=(isAssetSelected(asset))>Resource Role</mat-label>
              <mat-select [(ngModel)]="assetResourceAssignments[asset.key]" [disabled]=(!isAssetSelected(asset)) (selectionChange)="toggleAssetResourceAssignment(asset, $event.value)" multiple>
                <mat-option *ngFor="let resource of selectedResources" [disabled]="isMaxCountReached(asset) || isResourceAlreadyAssigned(resource,asset)" [value]="resource">
                  {{ resource.firstName }} {{ resource.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="role">
          <mat-header-cell *matHeaderCellDef> Assigned Role </mat-header-cell>
          <mat-cell *matCellDef="let asset">
            <mat-form-field appearance="fill">
              <mat-label *ngIf=(isAssetSelected(asset))>Resource Role</mat-label>
              <mat-select [(ngModel)]="assetRoleSelections[asset.key]" [disabled]=(!isAssetSelected(asset)) (selectionChange)="assignAssetRole(asset, $event.value)">
                <mat-option *ngFor="let role of assetRoles" [value]="role">
                  {{role}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="info">
          <mat-header-cell *matHeaderCellDef> Info </mat-header-cell>
          <mat-cell *matCellDef="let asset"> <strong>{{ getAssetSchedule(asset.key) }}</strong> </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="assetColumns"></mat-header-row>
        <mat-row  *matRowDef="let resource; columns: assetColumns;"></mat-row>
      </mat-table>
      <mat-paginator #paginator [hidden]="assetObjects.filteredData.length == 0" [length]="totalLength" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions">
      </mat-paginator>
      <div *ngIf="assetObjects.filteredData.length == 0" class="row">
        <div class="card card-pricing" style="box-shadow: 0 1px 4px 0 rgba(255, 255, 255, 0.14);">
          <div class="card-body">
            <div class="card-icon icon-primary">
              <i class="material-icons">search</i>
            </div>
            <h3 class="card-title">No Assets Found</h3>
            <p class="card-descriptiona">
              Try adjusting the search criteria for more results.
            </p>
          </div>
        </div>
      </div>
    </div>
    </mat-step>



    <mat-step>
      <ng-template matStepLabel>Additional Settings</ng-template>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Enter Additional Notes</mat-label>
        <input matInput [(ngModel)]="additionalNotes" placeholder="Type notes here...">
      </mat-form-field>
      
      <h4>Auto Dispatch Resources</h4>
        <mat-checkbox [checked]="(this.autoDispatch)" (change)="toggleAutoDispatch()"> Dispatch Resources automatically before scheduled time.
        </mat-checkbox>
        <br>
        <h4 *ngIf="(this.autoDispatch)">Current Audo Dispatch set to {{autoDispatchTime}} minutes before service time.</h4>
        <br>
        <mat-slider *ngIf="(this.autoDispatch)" class="col-sm-12"
          [thumbLabel]=true
          [(ngModel)]="autoDispatchTime"
          [max]="360"
          [min]="5"
          [tickInterval]="5"
          [step]="5"
          aria-labelledby="Auto Dispatch Timer"
          >
          <input matSliderThumb #slider value="autoDispatchTime">
        </mat-slider>
      <br><br>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Review</ng-template>
      <h3>Selected Resources
        <mat-icon *ngIf="(data.serviceInformation.requiredResourceCount && data.serviceInformation.requiredResourceCount > 0)" [style.color]="requiredResourcesMet ? 'green' : 'red'">
          {{ requiredResourcesMet ? 'check_circle' : 'cancel' }}
        </mat-icon>
      </h3>
      <p *ngIf="data.serviceInformation.requiredResourceCount && data.serviceInformation.requiredResourceCount > 0" [style.color]="requiredResourcesMet ? 'green' : 'red'">
        {{ selectedResources.length }}/{{ data.serviceInformation.requiredResourceCount }} resources selected
      </p>
      <ul>
        <li *ngFor="let resource of selectedResources">{{ resource.firstName }} {{ resource.lastName }} - {{ getResourceRole(resource.key) }}</li>
      </ul>
      <h3>Selected Assets
        <mat-icon *ngIf="(data.serviceInformation.requiredAssetCount && data.serviceInformation.requiredAssetCount > 0)" [style.color]="requiredAssetsMet ? 'green' : 'red'">
          {{ requiredAssetsMet ? 'check_circle' : 'cancel' }}
        </mat-icon>
      </h3>
      <p *ngIf="data.serviceInformation.requiredAssetCount && data.serviceInformation.requiredAssetCount > 0" [style.color]="requiredAssetsMet ? 'green' : 'red'">
        {{ selectedAssets.length }}/{{ data.serviceInformation.requiredAssetCount }} assets selected
      </p>
      <ul>
        <li *ngFor="let asset of selectedAssets">{{ asset.make }} {{ asset.model }} {{ asset.registrationNumber }} - {{ getAssetRole(asset.key) }}</li>
      </ul>
      <h3>Resource Assignments to Assets</h3>
      <div *ngFor="let assetKey of assetKeys">
        <strong>{{ getAssetName(assetKey) }}</strong>
        <ul>
          <li *ngFor="let resource of assetResourceAssignments[assetKey]">{{ resource.firstName }} {{ resource.lastName }}</li>
        </ul>
      </div>
      <h3>Additional Settings</h3>
      <ul>
        <li>Additional Notes: {{ additionalNotes }}</li>
        <li>Auto Dispatch Resources: {{ autoDispatch == true ? "Yes" : "No" }}</li>
        <li *ngIf="(autoDispatch)">Auto Dispatch Time: {{ autoDispatchTime }} min</li>
      </ul>
    </mat-step>
  </mat-horizontal-stepper>
</mat-dialog-content>


<mat-dialog-actions class="right-aligned-actions">
  <button mat-button [disabled]="stepper.selectedIndex == 0" (click)="goBack(stepper)" class="btn btn-primary" type="button">Back</button>
  <button mat-button style="padding-right: 30px;" [disabled]="(stepper.selectedIndex == (stepper.steps.length - 1))" (click)="goForward(stepper)" class="btn btn-primary" type="button">Next</button>
  <button mat-button (click)="onCancel()" class="btn">Cancel</button>
  <button mat-button style="background-color: red;" [disabled]="!requiredResourcesMet || !requiredAssetsMet" [title]="(!requiredResourcesMet ? 'Required resources not met. ' : '') + (!requiredAssetsMet ? 'Required assets not met.' : '')" (click)="onConfirm()" class="btn btn-primary" *ngIf="(!canSave || extraConfirmation)">Confirm</button>
</mat-dialog-actions> 